import { frontendURL } from '../../../../helper/URLHelper';

const kanban = accountId => ({
  parentNav: 'kanban',
  routes: ['kanban_index', 'kanban_funnels'],
  menuItems: [
    {
      icon: 'table-switch',
      label: 'KANBAN_PIPELINE',
      key: 'kanban_pipeline',
      toState: frontendURL(`accounts/${accountId}/kanban`),
      toStateName: 'kanban_index',
    },
    {
      icon: 'filter',
      label: 'KANBAN_FUNNELS',
      key: 'kanban_funnels',
      toState: frontendURL(`accounts/${accountId}/kanban/funnels`),
      toStateName: 'kanban_funnels',
    },
  ],
});

export default kanban;
